import { h } from 'preact';
import styled from 'styled-components';
import WrapperNewInvite from './WrapperNewInvite';
import {
  StyledCloseButton,
  StyledInvitationContent,
  StyledInvitationContainer,
  StyledInvitationTitle,
  StyledInvitationBody,
  StyledProvideButton,
  Button,
} from './WrapperNewInvite/MobileInviteStyle';
import {
  DEFAULT_CLOSE_BUTTON_TEXT,
} from '../../../common/constants';

export default function (props) {
  let isRtl =
    props.application.provisions.mobileInvitationLayout &&
    props.application.inviteData.isRtl;
  return (
    <WrapperNewInvite {...props}>
      <StyledInvitationContainer
        deviceType={props.application.deviceType}
        className="invitation-container"
      >
        <StyledInvitationContent
          deviceType={props.application.deviceType}
          isDirectionRtl={isRtl}
          className="invitation-content"
        >
          <StyledInvitationTitle
            deviceType={props.application.deviceType}
            className="invitation-title"
          >
            {props.application.inviteData.mobileDesign &&
              props.application.inviteData.mobileDesign.invitationHeadline}
          </StyledInvitationTitle>
          <StyledInvitationBody
            deviceType={props.application.deviceType}
            className="invitation-body"
          >
            {props.application.inviteData.mobileDesign.invitationText}
          </StyledInvitationBody>
        </StyledInvitationContent>
        <StyledProvideButton
          deviceType={props.application.deviceType}
          isDirectionRtl={isRtl}
          className="provide-feedback-button"
        >
          <Button
            backgroundColor={
              props.application.inviteData.mobileDesign
                .invitationProvideButtonColor
            }
            color={
              props.application.inviteData.mobileDesign
                .invitationProvideButtonTextColor
            }
            id="kplProvideButton"
            onClick={props.onProvideFeedbackClicked}
            name="provideButtonText"
            type="button"
            role="button"
          >
            {props.application.inviteData.mobileDesign.provideButtonText}
          </Button>
        </StyledProvideButton>
      </StyledInvitationContainer>
      <StyledCloseButton
        deviceType={props.application.deviceType}
        tabIndex="0"
        className="mobile-invite-close-btn"
        id="kplDeferButton"
        role="button"
        onClick={props.onDeferButtonClicked}
        aria-label={this.props.closeModalButton || DEFAULT_CLOSE_BUTTON_TEXT}
        isDirectionRtl={isRtl}
      >
        &times;
      </StyledCloseButton>
    </WrapperNewInvite>
  );
}
